import React, { useCallback, useMemo } from 'react';
import { useParams, useRouter } from 'next/navigation';
// import { Variant } from 'ct-types/product';
import { Hit } from 'instantsearch.js';
import { Highlight } from 'react-instantsearch-hooks-web';
import { Category } from 'shared/types/product/Category';
import { Product } from 'shared/types/product/Product';
import { AUTOCOMPLETE_PRODUCT_CLICKED } from 'helpers/constants/events';
import { Subset } from 'types/subset';
// import useVariantWithDiscount from 'helpers/hooks/useVariantWithDiscount';
import Image from 'frontastic/lib/image';
import Link from '../../link';
import { ITEM_CODE, ITEM_NAME } from 'helpers/constants/attributes';
import { localeMapping } from 'helpers/constants/localeMapping';
// import Prices from '../prices';

interface Props {
  hit: any;
  onClick?: () => void;
}

const SearchItem: React.FC<Props> = ({ hit, onClick }) => {
  const router = useRouter();


  const variant = useMemo(() => hit.variants?.[0], [hit]);
  const { locale } = useParams();
  const localeKey = localeMapping[locale];
  // const discountedVariant = useVariantWithDiscount(hit.variants as Partial<Variant>[]);

  const handleClick = useCallback(() => {
    onClick?.();

    router.push(hit._url ?? '#');
  }, [hit, onClick, router]);
  return (
    <Link link={hit._url} shallow>
      <div className="flex items-center gap-12 hover:bg-[#eee]">
        <div className="shrink-0 p-5 3xl:p-8">
          <div className="relative h-70 w-70 lg:h-40 lg:w-40 3xl:h-70 3xl:w-70">
            <Image
              src={encodeURI( hit?.selectedVariant?.images?.[0]
                ? hit?.selectedVariant?.images[0]
                : hit?.variants?.filter((variant: { id: any }) => variant.id === hit?.masterVariantID)?.[0]
                    ?.images?.[0]
                ? hit.variants?.filter((variant: { id: any }) => variant.id === hit?.masterVariantID)?.[0]
                    ?.images?.[0]
                : hit?.variants?.[0]?.images?.[0]
                ? hit?.variants?.[0]?.images?.[0]
                : '/images/no-image-placeholder/product-thumbnail.jpg')}
              fill
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
              style={{ objectFit: 'contain' }}
              onError={(event: any) => {
                event.target.id = '/images/no-image-placeholder/product-thumbnail.jpg';
                event.target.srcset = '/images/no-image-placeholder/product-thumbnail.jpg';
              }}
            />
          </div>
        </div>
        <div>
          <p className="text-16 uppercase text-primary-black">
            <Highlight attribute="hit.name" hit={hit} />
          </p>
          <div className="flex flex-col gap-4">
            <span className="text-16 font-medium capitalize text-[#333] lg:text-12 3xl:text-16">
              {hit?.selectedVariant?.attributes?.[ITEM_NAME]?.[`${localeKey}`] || hit?.name}
            </span>
            <span className="text-14 font-normal text-[#666] lg:text-10  3xl:text-14">
              {hit?.selectedVariant?.attributes?.[ITEM_CODE] || hit?.variants?.[0]?.attributes[ITEM_CODE]}
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default SearchItem;
